module.exports = __webpack_public_path__ + "img/people-26.e089e7f8.png";